export const propOr =
  (prop, defaultVal = undefined) =>
  (obj) => {
    return obj?.[prop] ?? defaultVal;
  };
